import { render } from "./Form-Tag-Pagos.vue?vue&type=template&id=6f003738"
import script from "./Form-Tag-Pagos.vue?vue&type=script&lang=js"
export * from "./Form-Tag-Pagos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__